import request from "../utils/request.js";


export function login(params) {
    return request.post("/user/login/", params)
}

export function logout() {
    return request.post("/user/logout/")
}
